import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getUserCount(id) {
  return requestMsg({
    url: '/user/getCount',
    param:{}
  })
}

export function getMerchantsCount(id) {
  return requestMsg({
    url: '/merchants/getCount',
    param:{}
  })
}

export function getSkuInfoCount(id) {
  return requestMsg({
    url: '/skuInfo/getCount',
    param:{}
  })
}

export function getOrderCount(id) {
  return requestMsg({
    url: '/order/getCount',
    param:{}
  })
}

// export function updateMerchants(merchants) {
//   let address = "";
//   for (let i = 0;i<merchants.detailAddress.length;i++){
//     address = address + merchants.detailAddress[i]
//   }
//   merchants.detailAddress = address;
//   return requestMsg({
//     url: '/merchants/updateMerchants',
//     data: JSON.stringify(merchants),
//     method: "POST",
//     headers : {"Content-Type" : "application/json;charset=utf-8"},
//   })
// }
